// ----------------------------------------------------------------------------
// Template: Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

//Scripts
import './ajax-cart-page';
import 'snippets/cart-js/cart-js';
import 'snippets/mini-cart/mini-cart';
import 'snippets/_containers/form/form-increment';
import iamotaEventHandler from 'assets/scripts/helpers/event-handler';

import 'sections/header/header';
import 'sections/footer/footer';

// Styles
import './_cart.scss';
